<div #reportContainer class="component-content">
  <!-- Título do período e categoria -->
  <div class="page-header-container">
    <!-- Loading State -->
    <div class="filters-container">
      <span class="filter-label">Filtrar</span>
      <div class="filter-buttons">
        <!-- Componente Exercise Calendar -->
        <app-exercise-calendar (periodChange)="onPeriodChange($event)" [initialYear]="selectedYear"
          [initialMonth]="selectedMonth" [disabled]="loading" [availableExercicios]="availableExercicios">
        </app-exercise-calendar>

        <button class="filter-btn" [class.active]="selectedFilter === 'VAREJO'" (click)="setFilter('VAREJO')"
          [disabled]="loading" appTrackClick trackEvent="varejo_raiox" trackCategory="reports"
          trackLabel="filter_varejo">
          Varejo
        </button>

        <button class="filter-btn" [class.active]="selectedFilter === 'FROTA'" (click)="setFilter('FROTA')"
          [disabled]="loading" appTrackClick trackEvent="frota_raiox" trackCategory="reports" trackLabel="filter_frota">
          Frota
        </button>


      </div>

      <app-export-document-button [disabled]="loading" [availableMonths]="availableExercicios"
        [initialStartYear]="selectedYear" [initialStartMonth]="selectedMonth" [initialEndYear]="selectedYear"
        [initialEndMonth]="selectedMonth" [canChoose]="true" (exportRequested)="onExportRequested($event)"
        (exportDirect)="onExportDirect()" (exportPdfModal)="exportPdfModal()" (exportExcelModal)="exportExcelModal($event)" (exportCancelled)="onExportCancelled()" class="export-button">
      </app-export-document-button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-state">
    Carregando dados...
  </div>

  <!-- Mensagem de erro HTTP -->
  <div *ngIf="errorMessage && !loading" class="error-message-container">
    <div class="error-message">
      <span>{{ errorMessage }}</span>
    </div>
  </div>

  <!-- Content -->
  <div #pdfContent *ngIf="!loading && !errorMessage && apiData" class="pdf-export-content">
    <!-- PRIMEIRA LINHA: Produtos de Lealdade (esquerda) + ISR & Penetration (direita) -->
    <div class="first-row">
      <!-- Card Produtos de Lealdade -->
      <div class="chart-card produtos-lealdade with-header">
        <div class="chart-container">
          <div class="card-title-container">
            <h3 class="card-title">Produtos de Lealdade</h3>
            <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
              getCategoryName(selectedFilter) }}</div>
          </div>
          <app-horizontal-bar-dots-chart [data]="horizontalBarData" [barColor]="'#4CC7F4'" [title]="''">
          </app-horizontal-bar-dots-chart>
        </div>
        <!-- Legenda -->
        <div class="chart-legend-container">
          <div class="legend-divider"></div>
          <div class="chart-legend">
            Produtos que geram "fluxo de loja" no pós venda. O percentual representa o volume de vendas de cada produto
            sobre o total de contrato.
          </div>
        </div>
      </div>

      <div class="chart-card isr-penetration">
        <div class="two-columns-layout">
          <!-- Coluna ISR -->
          <!-- Coluna ISR (mantém como está) -->
          <div class="isr-column">
            <div class="card-title-container">
              <h3 class="isr-title">ISR</h3>
              <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
                getCategoryName(selectedFilter) }}</div>
            </div>
            <div class="isr-items">
              <div class="isr-item">
                <span class="isr-name">{{ isrData.dealer.name }}</span>
                <span class="isr-percentage">{{ isrData.dealer.percentage }}%</span>
              </div>
              <div class="isr-item">
                <span class="isr-name">{{ isrData.regional.name }}</span>
                <span class="isr-percentage">
                  <img [src]="getArrowIcon('isr', 'regional')" class="arrow-icon" />
                  {{ isrData.regional.percentage }}%
                </span>
              </div>
              <div class="isr-item">
                <span class="isr-name">{{ isrData.national.name }}</span>
                <span class="isr-percentage">
                  <img [src]="getArrowIcon('isr', 'national')" class="arrow-icon" />
                  {{ isrData.national.percentage }}%
                </span>
              </div>
            </div>
          </div>

          <!-- Coluna Penetration (COM CLASSES IGUAIS AO ISR) -->
          <div class="isr-column">
            <div class="card-title-container">
              <h3 class="isr-title">Penetration</h3> <!-- usa isr-title -->
              <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
                getCategoryName(selectedFilter) }}</div>
            </div>
            <div class="isr-items"> <!-- usa isr-items -->
              <div class="isr-item"> <!-- usa isr-item -->
                <span class="isr-name">{{ penetrationData.dealer.name }}</span> <!-- usa isr-name -->
                <span class="isr-percentage">{{ penetrationData.dealer.percentage }}%</span> <!-- usa isr-percentage -->
              </div>
              <div class="isr-item"> <!-- usa isr-item -->
                <span class="isr-name">{{ penetrationData.regional.name }}</span> <!-- usa isr-name -->
                <span class="isr-percentage">
                  <img [src]="getArrowIcon('penetration', 'regional')" class="arrow-icon" />
                  {{ penetrationData.regional.percentage }}%
                </span>
              </div>
              <div class="isr-item"> <!-- usa isr-item -->
                <span class="isr-name">{{ penetrationData.national.name }}</span> <!-- usa isr-name -->
                <span class="isr-percentage">
                  <img [src]="getArrowIcon('penetration', 'national')" class="arrow-icon" />
                  {{ penetrationData.national.percentage }}%
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Índice de Comissão -->
        <div class="indice-comissao-container">
          <h3 class="indice-comissao-title">Índice de Comissão</h3>
          <div class="indice-comissao-line">
            <span class="indice-comissao-value">{{ isrData.indiceComissao }}%</span>
          </div>
        </div>

        <!-- Legenda -->
        <div class="chart-legend-container">
          <div class="legend-divider"></div>
          <div class="chart-legend">
            Insurance service ratio (ISR) representa o volume de seguros e serviços sobre o total de contratos.
            Penetration representa o volume de contratos novos sobre os veículos faturados.
            Índice de comissão vigente para o mês tem relação direta da performance de ISR e Penetration.
          </div>
        </div>
      </div>
    </div>

    <!-- SEGUNDA LINHA: Veículos Faturados + Ratio Usados + Volume + Valores -->
    <div class="second-row-combined">
      <!-- Veículos Faturados -->
      <div class="chart-card veiculos-faturados with-header">
        <div class="chart-header">
          <div class="card-title-container">
            <h3 class="chart-title">Veículos Faturados</h3>
            <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
              getCategoryName(selectedFilter) }}</div>
          </div>
        </div>
        <div class="chart-container">
          <app-vertical-bar-simple-chart [data]="veiculosFaturadosData" [labels]="veiculosFaturadosLabels"
            [barColor]="veiculosFaturadosColors" [showValues]="true">
          </app-vertical-bar-simple-chart>
        </div>
        <!-- Legenda -->
        <div class="chart-legend-container">
          <div class="legend-divider"></div>
          <div class="chart-legend">
            Representa o volume do mês de veículos faturado pela montadora.
          </div>
        </div>
      </div>

      <!-- Ratio Usados -->
      <div class="chart-card ratio-usados with-header">
        <div class="chart-header">
          <div class="card-title-container">
            <h3 class="chart-title">Ratio Usados</h3>
            <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
              getCategoryName(selectedFilter) }}</div>
          </div>
        </div>
        <div class="chart-container">
          <app-vertical-bar-simple-chart [data]="ratioUsadosData" [labels]="ratioUsadosLabels"
            [barColor]="ratioUsadosColors" [showValues]="true" [decimalPlaces]="1">
          </app-vertical-bar-simple-chart>
        </div>
        <!-- Legenda -->
        <div class="chart-legend-container">
          <div class="legend-divider"></div>
          <div class="chart-legend">
            Representa o volume de contrato de usados + novos de outras marcas sobre o volume de contratos novos
            Volkswagen.
            Exemplo: 0.3, para cada 10 contratos de veículos novos Volkswagen, 3 são de usados + Novos outras marcas.
          </div>
        </div>
      </div>

      <!-- Volume de Veículos -->
      <div class="chart-card volume-veiculos with-header">
        <div class="chart-header">
          <div class="card-title-container">
            <h3 class="chart-title">Volume de Veículos Financiados</h3>
            <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
              getCategoryName(selectedFilter) }}</div>
          </div>
        </div>
        <div class="chart-container">
          <div class="double-charts-container">
            <!-- Gráfico Novos -->
            <div class="chart-wrapper">
              <h4 class="chart-subtitle">Novos</h4>
              <app-vertical-bar-simple-chart [data]="novosSimpleData" [labels]="simpleChartLabels"
                [barColor]="simpleBarsColors" [showValues]="true" [title]="''">
              </app-vertical-bar-simple-chart>
            </div>

            <!-- Gráfico Usados -->
            <div class="chart-wrapper">
              <h4 class="chart-subtitle">Usados</h4>
              <app-vertical-bar-simple-chart [data]="usadosSimpleData" [labels]="simpleChartLabels"
                [barColor]="simpleBarsColors" [showValues]="true" [title]="''">
              </app-vertical-bar-simple-chart>
            </div>
          </div>
        </div>
        <!-- Legenda -->
        <div class="chart-legend-container">
          <div class="legend-divider"></div>
          <div class="chart-legend">
            Representa o volume total de contratos novos Volkswagen e usados mais novos outras marcas.
          </div>
        </div>
      </div>

      <div class="valores-column">
        <!-- Card Valor Financiado -->
        <div class="value-card with-header">
          <div class="chart-header">
            <div class="card-title-container">
              <h3 class="chart-title">Valor Financiado</h3>
              <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
                getCategoryName(selectedFilter) }}</div>
            </div>
          </div>
          <div class="value-items">
            <div class="value-item">
              <span class="value-name">{{ concessionariaNome }}</span>
              <span class="value-percentage">
                {{ primeiroCardValores.concessionaria }}
              </span>
            </div>
            <div class="value-item">
              <span class="value-name">Referência Regional</span>
              <span class="value-percentage">
                <img [src]="getValueArrowIcon('valor', 'regional')" class="arrow-icon" />
                <span class="percent-chip">{{ getValuePercentage('valor', 'regional') }}</span>
                {{ primeiroCardValores.mediaRegional }}
              </span>
            </div>
            <div class="value-item">
              <span class="value-name">Referência Nacional</span>
              <span class="value-percentage">
                <img [src]="getValueArrowIcon('valor', 'national')" class="arrow-icon" />
                <span class="percent-chip">{{ getValuePercentage('valor', 'national') }}</span>
                {{ primeiroCardValores.mediaNacional }}
              </span>
            </div>
          </div>
          <!-- Legenda -->
          <div class="chart-legend-container">
            <div class="legend-divider"></div>
            <div class="chart-legend">
              Representa o total do valor financiado que é o valor do bem menos o valor de entrada.
            </div>
          </div>
        </div>

        <!-- Card Comissões Pagas -->
        <div class="value-card with-header">
          <div class="chart-header">
            <div class="card-title-container">
              <h3 class="chart-title">Comissão</h3>
              <div class="card-period-info">{{ getMonthName(selectedMonth) }} {{ selectedYear }} - {{
                getCategoryName(selectedFilter) }}</div>
            </div>
          </div>
          <div class="value-items">
            <div class="value-item">
              <span class="value-name">{{ concessionariaNome }}</span>
              <span class="value-percentage">
                -
              </span>
            </div>
            <div class="value-item">
              <span class="value-name">Referência Regional</span>
              <span class="value-percentage">
                <span class="percent-chip">-</span>
                -
              </span>
            </div>
            <div class="value-item">
              <span class="value-name">Referência Nacional</span>
              <span class="value-percentage">
                <span class="percent-chip">-</span>
                -
              </span>
            </div>
          </div>
          <!-- Legenda -->
          <div class="chart-legend-container">
            <div class="legend-divider"></div>
            <div class="chart-legend">
              Valor de comissão gerada.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Informação de data de fechamento -->
  <div class="closed-date-info" *ngIf="!loading && !errorMessage">
    Informações válidas de fechamento até: {{ closedDate }}
  </div>

  <!-- Export Download Modal -->
  <app-export-download-modal
    [show]="showExportModal"
    [fileName]="exportFileName"
    [fileBlob]="exportFileBlob"
    [emailSubject]="exportEmailSubject"
    [emailBody]="exportEmailBody"
    (close)="showExportModal = false"
    (download)="handleExportModalDownload()"
  ></app-export-download-modal>
</div>
